import React from 'react';
import { Badge, Skeleton, Text } from '@/components/ui';
import { getFileExtension } from '@/utils/fileUtils';

interface FileFormatCellProps {
  value?: unknown;
  filename?: string;
  extension?: string;
  variant?: 'outlined' | 'surface' | 'soft';
  render?: () => React.ReactNode;
}

function FileFormatCell({
  value,
  filename,
  extension,
  variant = 'outlined',
  render,
}: FileFormatCellProps) {
  if (render) {
    return <>{render()}</>;
  }

  // Extract extension from filename or use provided extension
  let fileExtension = extension;

  // Priority 1: Use provided extension prop
  if (fileExtension) {
    // Extension is already provided
  }
  // Priority 2: Extract from filename prop
  else if (filename) {
    fileExtension = getFileExtension(filename);
  }
  // Priority 3: Use value if it's a string (could be extension or filename)
  else if (typeof value === 'string' && value.length > 0) {
    // Check if value looks like an extension (no path separators, short)
    if (!value.includes('/') && !value.includes('\\') && value.length < 20) {
      fileExtension = value;
    } else {
      // Try to extract from value if it's a filename
      fileExtension = getFileExtension(value);
    }
  }

  if (!fileExtension) {
    return (
      <Text
        variant="inherit"
        className="data-cell__file-format"
        color="textSecondary"
      >
        —
      </Text>
    );
  }

  // Add dot if not present
  const displayExtension = fileExtension.startsWith('.')
    ? fileExtension
    : `.${fileExtension}`;

  return (
    <Badge
      size="small"
      variant={variant}
      color="default"
      className="data-cell__file-format"
    >
      {displayExtension}
    </Badge>
  );
}

export function FileFormatCellSkeleton() {
  return <Skeleton style={{ width: '60px', height: 16 }} />;
}

export default FileFormatCell;
